export const AGENDA_SOLUTION_CONSTANT = {
    // テーブル名
    TABLE: 'view_user',
    // csvファイル名
    CSV_FILENAME: 'ユーザ一覧'
  };
  